import { commonLovConfig } from "../../core/modules/admin-modules/configuration/commonlov/models/commonlov.model";
import { bloodGroupConfig, caseTypeConfig, categoryConfig, cityConfig, contractStatusConfig, countryConfig, dosageFormConfig, languageTypeConfig, packageTypeConfig, patientShareConfig, policyStatusConfig, roomTypeConfig, routesOfAdministrationConfig, sbsCodeConfig, standardNameConfig, stateConfig, unitTypeConfig, visaTypeConfig } from "../../core/modules/admin-modules/configuration/master-data/models/master-data.model";
import { medicalDeviceConfig } from "../../core/modules/admin-modules/configuration/medical-device/models/medical-device.model";
import { serviceCodeConfig } from "../../core/modules/admin-modules/configuration/service-code/models/service-code.model";
import { beneficiaryConfig } from "../../core/modules/admin-modules/beneficiary/models/beneficiary.model";
import { serviceTypeConfig } from "../../core/modules/admin-modules/configuration/service-types/models/service-type.model";
import { contractConfig } from "../../core/modules/admin-modules/contract/contracts/models/contracts.model";
import { networkConfig } from "../../core/modules/admin-modules/configuration/networks/models/networks.model";
import { managePriceListConfig } from "../../core/modules/admin-modules/configuration/pricelist/models/pricelist.model";
import { insuranceCompanyConfig } from "../../core/modules/admin-modules/insurance-company/models/insurance-company.model";
import { benefitConfig } from "../../core/modules/admin-modules/configuration/benefit/models/benefit.model";
import { PolicyBeneficiary, policyConfig } from "../../core/modules/admin-modules/policy/policy-and-product/models/policy-and-product.model";
import { policyClassConfig } from "../../core/modules/admin-modules/configuration/policy-class/models/policy-class.model";
import { providerAdministrationContactConfig, providerConfig, providerMedicalContactConfig } from "../../core/modules/admin-modules/provider/models/provider.model";
import { loincCodeConfig } from "../../core/modules/admin-modules/configuration/loinc-code/models/loinc-code.model";
import { claimTypeConfig } from "../../core/modules/admin-modules/configuration/claim-type/models/claim-type.model";
import { specialtyConfig } from "../../core/modules/admin-modules/configuration/speciality/models/speciality-models";
import { physicianConfig } from '../../core/modules/admin-modules/configuration/physician/models/physician.model';
import { reasonsConfig } from "../../core/modules/admin-modules/configuration/reasons/reasons-list/models/reasons-list.model";
import { diagnosisConfig } from "../../core/modules/admin-modules/configuration/diagnosis/model/diagnosis.model";
import { bodysubSiteConfig } from "../../core/modules/admin-modules/configuration/bodysubsite/model/bodysubsite.model";
import { encounterClassConfig } from "../../core/modules/admin-modules/configuration/encounter-class/models/encounter-class.model";
import { morphologyConfig } from "../../core/modules/admin-modules/configuration/morphology/morphology-list/models/morphology.model";
import { ExportKey } from "../constants/master-data.enum";
import { uploadConfig } from "../../core/modules/admin-modules/claim/upload-claims/models/upload-claims.model";
import { eligibilityConfig } from "../../core/modules/admin-modules/eligibility/eligibility-transactions/models/eligibility-transactions.model";
import { managePreAuthRequestConfig } from "../../core/modules/admin-modules/pre-auth/preauth-request/models/preauth-request.model";
import { claimHistoryConfig } from "../../core/modules/admin-modules/claim/claim-history/models/Claim-history.model";
import { viewClaimConfig } from "../../core/modules/admin-modules/claim/view-claims/models/view-claims.model";
import { paymentReconciliationconfig } from "../../core/modules/admin-modules/payment-reconciliation/models/payment-reconciliation.model";
import { paymentConfig } from "../../core/modules/admin-modules/payment/model/payment-list.model";
import { pharmaceuticalFormConfig } from "../../core/modules/admin-modules/configuration/pharmaceutical-form/models/pharmaceutical-form.model";
import { dosageTypeconfig } from "../../core/modules/admin-modules/configuration/dosage-type/models/dosage-type.model";
import { PatientConfig, UserConfig } from "../../core/modules/admin-modules/administrator/users/models/user.model";
import { roleConfig } from "../../core/modules/admin-modules/administrator/role-and-permission/models/role-config.model";
import { permissionConfig } from "../../core/modules/admin-modules/administrator/role-and-permission/models/permission-config.model";
import { ucumCodeconfig } from "../../core/modules/admin-modules/configuration/ucum-code/models/ucum-code-model";
import { sendForgotPasswordEmail } from "../../core/modules/admin-modules/public/reset-password/models/reset-password.component.models";
import { bodySiteConfig } from "../../core/modules/admin-modules/configuration/bodysite/models/bodysite.model";
import { faqConfig } from "../../core/modules/admin-modules/administrator/faq/models/faq.model";

const mapper = {
    InsuranceCompany: insuranceCompanyConfig,
    Beneficiary: beneficiaryConfig,
    Policy: policyConfig,
    PolicyBeneficiary: PolicyBeneficiary,
    Provider: providerConfig,
    Contract: contractConfig,
    Network: networkConfig,
    PriceList: managePriceListConfig,
    PolicyClass: policyClassConfig,
    Benefit: benefitConfig,
    "Medical Device": medicalDeviceConfig,
    CommonLovs: commonLovConfig,
    Speciality: specialtyConfig,
    Physician: physicianConfig,
    LoincCode: loincCodeConfig,
    ClaimType: claimTypeConfig,
    Reason: reasonsConfig,
    Diagnosis: diagnosisConfig,
    BodySubsite: bodysubSiteConfig,
    BodySite: bodySiteConfig,
    EncounterClass: encounterClassConfig,
    Morphology: morphologyConfig,
    [ExportKey.PolicyStatus]: policyStatusConfig,
    [ExportKey.RoomType]: roomTypeConfig,
    [ExportKey.SBSCode]: sbsCodeConfig,
    [ExportKey.ContractStatus]: contractStatusConfig,
    [ExportKey.BloodGroup]: bloodGroupConfig,
    [ExportKey.VisaType]: visaTypeConfig,
    [ExportKey.PatientShareType]: patientShareConfig,
    [ExportKey.RoutesOfAdministration]: routesOfAdministrationConfig,
    [ExportKey.CaseType]: caseTypeConfig,
    [ExportKey.DosageForm]: dosageFormConfig,
    [ExportKey.PackageType]: packageTypeConfig,
    [ExportKey.UnitType]: unitTypeConfig,
    [ExportKey.Category]: categoryConfig,
    [ExportKey.Country]: countryConfig,
    [ExportKey.State]: stateConfig,
    [ExportKey.City]: cityConfig,
    [ExportKey.ServiceCode]: serviceCodeConfig,
    [ExportKey.ServiceType]: serviceTypeConfig,
    [ExportKey.StandardName]: standardNameConfig,
    [ExportKey.PreferredLanguage]: languageTypeConfig,
    Claim: uploadConfig,
    EligibilityRequest: eligibilityConfig,
    Approval: managePreAuthRequestConfig,
    ClaimUploadHistoryStatisticDetails: claimHistoryConfig,
    ClaimUploadStatisticDetails: viewClaimConfig,
    Payment: paymentConfig,
    PaymentReconciliation: paymentReconciliationconfig,
    PharmaceuticalForm: pharmaceuticalFormConfig,
    DosageType: dosageTypeconfig,
    User: UserConfig,
    Role: roleConfig,
    Permission: permissionConfig,
    UcumCode: ucumCodeconfig,
    PasswordReset: UserConfig,
    TokenValidate: UserConfig,
    SendForgotPasswordEmail: sendForgotPasswordEmail,
    login: UserConfig,
    Patient: PatientConfig,
    PatientLogin: PatientConfig,
    Faq: faqConfig,
    ProviderMedicalContact: providerMedicalContactConfig,
    ProviderAdministrationContact: providerAdministrationContactConfig,
};

export function getLabelMapper(element) {
    return convertKeysToLowercase(mapper[element]);
}

function convertKeysToLowercase(obj) {
    const newObj = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key))
            newObj[key.toLowerCase()] = obj[key];
    }
    return newObj;
}